import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/Index'
import recruit from '../views/recruit'

Vue.use(Router)

export default new Router({
  base: '/',
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: recruit
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js